import QRCode from "qrcode.react";
import { useTranslation } from "react-i18next";

import {
  ResponsivePrimaryAction,
  ResponsiveTitleBar,
  LinkButton,
  DevNote,
} from "../../Atoms";
import { useBrand } from "../../BrandContext";
import { useLoadedCustomerTab } from "../CustomerTab/queries";
import { LetTheGoodTimesRoll } from "./JoinBillSplitSession";

export const Share = () => {
  const { data: customerTab } = useLoadedCustomerTab();
  const origin = window.location.origin;
  const url = `${origin}/t/${customerTab?.uuid}`;
  const { t } = useTranslation();
  const brand = useBrand();
  return (
    <div className="mx-auto max-w-screen-sm space-y-32 text-center">
      <ResponsiveTitleBar>{t("billSplit.shareWithOthers")}</ResponsiveTitleBar>
      <div className="space-y-64">
        <LetTheGoodTimesRoll />
        <div className="flex justify-center">
          <QRCode
            id=""
            value={url}
            bgColor={brand.secondaryColor}
            fgColor={brand.brandColor}
            style={{ height: "200px", width: "200px" }}
          />
        </div>
        <div>
          <a
            className="text-venue-highlight underline"
            onClick={(e) => {
              try {
                navigator.share({
                  title: t("billSplit.shareTitle"),
                  text: t("billSplit.shareText"),
                  url,
                });
                e.preventDefault();
              } catch (e) {
                console.error(e);
              }
            }}
            href={url}
          >
            <div>{t("billSplit.shareTheLink")}</div>
          </a>
        </div>
        <ResponsivePrimaryAction>
          <LinkButton primary to="..">
            {t("buttons.done")}{" "}
          </LinkButton>
        </ResponsivePrimaryAction>
      </div>
    </div>
  );
};
